import firebase from 'firebase/app';
import 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyC_6MXQSypM9mkM5gDXbm2TpX_SWFijnds",
  authDomain: "goopar-corporate.firebaseapp.com",
  projectId: "goopar-corporate",
  storageBucket: "goopar-corporate.appspot.com",
  messagingSenderId: "337662311611",
  appId: "1:337662311611:web:85eafc5fc551f7b63efd9e"
}
// Initialize Firebase
if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig)
}

export const functions = firebase.functions();
export default firebase
